import { ENVIRONMENT_CONSTANT } from "./env.constant";

export const AUTHENTICATION_ENDPOINT = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}connect/authenticate/`